export default __webpack_public_path__ + "static/media/gincana-2020.cebcb9cf.pdf";